import {combineReducers} from 'redux';
import fileUpload from './addoreditframe/components/eyeweareditor/components/fileupload/fileUploadReducer';

export default combineReducers({
  fileUpload,
});
